module.exports = __webpack_public_path__ + "img/logo-white.d9b30eeb.png";